import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en_US from './locales/en_US.json';
import ar_AR from './locales/ar_AR.json';
import ur_PK from './locales/ur_PK.json';
import hi_IN from './locales/hi_IN.json';

const resources = {
  en_US: {
    translation: en_US
  },
  ar_AE: {
    translation: ar_AR
  },
  ur_PK: {
    translation: ur_PK
  },
  hi_IN: {
    translation: hi_IN
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'en_US', // default language
    fallbackLng: 'en_US',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
